<div class="relative overflow-hidden">
  
  <!-- Przycisk zamknięcia - X w prawym górnym rogu -->
  <button 
    mat-icon-button 
    (click)="close()"
    class="!absolute top-2 right-2 z-20 text-gray-400 hover:text-gray-600 dark:hover:text-gray-200">
    <mat-icon [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
  </button>

  <!-- Background decoration -->
  <div class="absolute inset-0 -z-10 pointer-events-none overflow-hidden">
    <div class="absolute -top-32 -right-32 w-96 h-96 bg-gradient-to-br rounded-full blur-3xl" [ngClass]="planBgGradient"></div>
    <div class="absolute -bottom-32 -left-32 w-80 h-80 bg-gradient-to-tr from-primary-500/20 to-purple-500/20 rounded-full blur-3xl"></div>
  </div>

  <div class="relative z-10 p-6 sm:p-8">
    
    <!-- Header z ikoną -->
    <div class="flex flex-col items-center text-center mb-6">
      <div class="relative">
        <div class="absolute inset-0 bg-gradient-to-br rounded-full blur-xl animate-pulse" [ngClass]="planBgGradient"></div>
        <div class="relative w-20 h-20 rounded-2xl bg-gradient-to-br flex items-center justify-center shadow-lg" [ngClass]="planGradient">
          <mat-icon [svgIcon]="planIcon" class="!w-10 !h-10 text-white"></mat-icon>
        </div>
      </div>
      
      <h2 class="mt-6 text-2xl sm:text-3xl font-extrabold text-gray-900 dark:text-white tracking-tight">
        Funkcja Premium
      </h2>
      
      <p class="mt-3 text-gray-500 dark:text-gray-400 text-base max-w-sm">
        <span class="font-semibold text-gray-700 dark:text-gray-300">{{ data.featureName }}</span> 
        {{ data.featureDescription || 'jest dostępna w wyższym planie subskrypcji.' }}
      </p>
    </div>

    <!-- CTA Card - zachęta do zakupu -->
    <div class="relative overflow-hidden rounded-2xl bg-white dark:bg-gradient-to-br dark:from-gray-900 dark:via-gray-800 dark:to-gray-900 p-6 mb-6 shadow-xl">
      
      <!-- Dekoracja -->
      <div class="absolute top-0 right-0 w-48 h-48 bg-gradient-to-br rounded-full blur-2xl opacity-30 dark:opacity-100" [ngClass]="planBgGradient"></div>
      <div class="absolute bottom-0 left-0 w-32 h-32 bg-gradient-to-tr from-blue-500/10 dark:from-blue-500/20 to-cyan-500/10 dark:to-cyan-500/20 rounded-full blur-2xl"></div>
      
      <div class="relative z-10">
        <div class="flex items-center gap-2 mb-3">
          <mat-icon [svgIcon]="'tabler_outline:sparkles'" class="!w-5 !h-5" [ngClass]="badgeTextColor"></mat-icon>
          <span class="text-sm font-semibold uppercase tracking-wider" [ngClass]="badgeTextColor">Wymagany plan {{ planLabel }}</span>
        </div>
        
        <h3 class="text-xl font-bold text-gray-900 dark:text-white mb-4">
          Odblokuj tę funkcję i więcej!
        </h3>
        
        <!-- Korzyści -->
        <div class="space-y-3">
          <div class="flex items-center gap-3">
            <div class="w-5 h-5 rounded-md bg-gradient-to-br from-green-400 to-green-600 flex items-center justify-center flex-shrink-0 shadow-sm">
              <mat-icon [svgIcon]="'tabler_outline:check'" class="!w-3.5 !h-3.5 text-white"></mat-icon>
            </div>
            <span class="text-gray-700 dark:text-gray-300 text-[15px] font-medium leading-5">{{ data.featureName }}</span>
          </div>
          <div class="flex items-center gap-3">
            <div class="w-5 h-5 rounded-md bg-gradient-to-br from-green-400 to-green-600 flex items-center justify-center flex-shrink-0 shadow-sm">
              <mat-icon [svgIcon]="'tabler_outline:check'" class="!w-3.5 !h-3.5 text-white"></mat-icon>
            </div>
            <span class="text-gray-700 dark:text-gray-300 text-[15px] font-medium leading-5">
              <ng-container [ngSwitch]="data.requiredStage">
                <ng-container *ngSwitchCase="1">30 dokumentów miesięcznie</ng-container>
                <ng-container *ngSwitchCase="2">Bez limitu dokumentów</ng-container>
                <ng-container *ngSwitchCase="3">Wszystkie funkcje premium</ng-container>
              </ng-container>
            </span>
          </div>
          <div *ngIf="data.requiredStage === 2" class="flex items-center gap-3">
            <div class="w-5 h-5 rounded-md bg-gradient-to-br from-green-400 to-green-600 flex items-center justify-center flex-shrink-0 shadow-sm">
              <mat-icon [svgIcon]="'tabler_outline:check'" class="!w-3.5 !h-3.5 text-white"></mat-icon>
            </div>
            <span class="text-gray-700 dark:text-gray-300 text-[15px] font-medium leading-5">Pełna historia dokumentów</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Przycisk - główny CTA -->
    <button 
      (click)="goToSubscription()"
      class="group relative w-full h-14 inline-flex items-center justify-center text-base font-bold transition-all duration-300 rounded-xl overflow-hidden bg-gradient-to-r shadow-lg hover:shadow-xl hover:scale-[1.02] active:scale-100"
      [ngClass]="[buttonGradient, shadowColor]">
      <span class="relative z-10 flex items-center gap-3" [ngClass]="buttonTextColor">
        <mat-icon [svgIcon]="planIcon" class="!w-6 !h-6" [ngClass]="buttonTextColor"></mat-icon>
        <span>Przejdź na {{ planLabel }}</span>
        <mat-icon [svgIcon]="'tabler_outline:arrow-right'" class="!w-5 !h-5 transition-transform group-hover:translate-x-1" [ngClass]="buttonTextColor"></mat-icon>
      </span>
      <div class="absolute inset-0 bg-gradient-to-r from-white/0 via-white/20 to-white/0 translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700"></div>
    </button>

    <!-- Trust signal -->
    <div class="mt-4 flex items-center justify-center gap-4 text-xs text-gray-400">
      <div class="flex items-center gap-1.5">
        <mat-icon [svgIcon]="'tabler_outline:shield-check'" class="!w-4 !h-4 text-green-500"></mat-icon>
        <span>Bezpieczne płatności</span>
      </div>
      <div class="flex items-center gap-1.5">
        <mat-icon [svgIcon]="'tabler_outline:calendar-off'" class="!w-4 !h-4 text-blue-500"></mat-icon>
        <span>Bez zobowiązań</span>
      </div>
    </div>
  </div>
</div>
